document.addEventListener('DOMContentLoaded', () => {
  const faqOptions = document.getElementsByClassName("topshop-faq-button")
  const faqMobileSelector = document.getElementById("mobile-faq-selector");

  if (faqMobileSelector) {
    faqMobileSelector.addEventListener('change', (ev) => showQuestionSet(ev.target.value));

    Array.from(faqOptions).forEach(
      (link) => link.addEventListener('click', (el)=> desktopSelectQuestionSet(el.target))
    )

     desktopSelectQuestionSet(document.querySelector(".topshop-faq-button:first-child"))
  }
})

function findQuestionRoot(target){
  return target.closest('.topshop-question-and-answer');
}

function desktopSelectQuestionSet(target){
  const categoryName = target.getAttribute('data-category-name');
  showQuestionSet(categoryName);
  markButtonSelected(target);
}

function showQuestionSet(categoryName){
  const questionLists = document.getElementsByClassName("topshop-faq-inteface__questions")
  Array.from(questionLists).forEach(
    (question) => (question.getAttribute("data-questions-for")===categoryName ? question.classList.remove("hidden") : question.classList.add("hidden"))
  )
}

function markButtonSelected(target){
  // <!-- Current: "bg-primary-100 text-primary-700", Default: "text-gray-500 hover:text-gray-700" -->
  const currentClassName = ['bg-primary-200/50', 'text-primary-700'];
  const defaultClassName = ['bg-gray-100', 'text-gray-500', 'hover:text-gray-700'];

  const categoryButtons = document.getElementsByClassName('topshop-faq-button');

  Array.from(categoryButtons).forEach((button) => {
    button.classList.remove(...currentClassName);
    button.classList.add(...defaultClassName);
  });
  target.classList.add(...currentClassName);
}
